import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Nana Kofi Aferi </span>
            from <span className="purple"> Accra, Ghana.</span>
            <br />
            I am currently employed as an Engineering Manager at Adaptive Computing Solutions.
            <br />
            Results-driven Project Manager with a deep understanding of mobile application development, web<br/>
            technologies, and emerging trends. Proficient in leading cross-functional teams, ensuring project <br/>
            success within scope, budget, and timeline. Strong analytical and problem-solving skills with a keen eye for<br/>
            detail. Excellent communication and interpersonal abilities, fostering effective collaboration with stakeholders at all levels.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Riding bikes
            </li>
            <li className="about-activity">
              <ImPointRight /> Martial Arts
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Speed is a given but smooth is an art"{" "}
          </p>
          <footer className="blockquote-footer">naferio solutions</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
